// extracted by mini-css-extract-plugin
module.exports = {"container":"Choices_container__3uP8J","choice":"Choices_choice__1wAdf","choiceBox":"Choices_choiceBox__2SNmI","text":"Choices_text__3az2E"};